/**
 * Expect a blob as input (generally from a request's response data)
 * This function will create an URL for the resource and automatically
 * access it to download the final file.
 * @param {Object} fileBlob
 * @param {String} fileName
 */
export const downloadFile = (fileBlob: any, fileName: string) => {
  const file_path = URL.createObjectURL(fileBlob);
  const a = document.createElement('a');
  a.href = file_path;
  a.download = fileName ?? 'Contratto di gioco';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
